import React from 'react';
import { Routes, Route } from 'react-router-dom';
import LocationList from './LocationList';
import LocationForm from './LocationForm';

const Locations = () => {
  return (
    <Routes>
      <Route index element={<LocationList />} />
      <Route path="new" element={<LocationForm />} />
      <Route path=":id/edit" element={<LocationForm />} />
    </Routes>
  );
};

export default Locations;
